import React from "react"
import { Box } from "@mallardbay/lib-react-components"

import type { ListingType } from "~graphql/generated/graphql"

import PriceRangeFilter from "./price-range"
import TypeSelector from "./type-selector"
import SpeciesSelector from "./species-selector"
import AmenitySelector from "./amenity-selector"
import DatepickerSearchFilter from "./datepicker-search-filter"
import LodgingFilter from "./lodging-filter"

interface Props {
    readonly priceMin: number | undefined
    readonly setPriceMin: (priceMin: number | undefined) => void
    readonly priceMax: number | undefined
    readonly setPriceMax: (priceMax: number | undefined) => void
    readonly startDate: number | undefined
    readonly setStartDate: (startDate: number | undefined) => void
    readonly endDate: number | undefined
    readonly setEndDate: (startDate: number | undefined) => void
    readonly type: ListingType | undefined
    readonly setType: (type: ListingType | undefined) => void
    readonly species: string[]
    readonly setSpecies: (species: string[]) => void
    readonly amenities: string[]
    readonly setAmenities: (amenities: string[]) => void
    readonly hasIncludedLodging: true | undefined
    readonly setHasIncludedLodging: (isIncluded: true | undefined) => void
    readonly shouldClear: boolean
    readonly setShouldClear: (shouldClear: boolean) => void
}

export default function SearchFilters({
    priceMin,
    setPriceMin,
    priceMax,
    setPriceMax,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    type,
    setType,
    species,
    setSpecies,
    amenities,
    setAmenities,
    hasIncludedLodging,
    setHasIncludedLodging,
    shouldClear,
    setShouldClear,
}: Props) {
    const styles = useStyles()

    return (
        <Box style={styles.root}>
            <DatepickerSearchFilter
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />
            <PriceRangeFilter
                priceMin={priceMin}
                setPriceMin={setPriceMin}
                priceMax={priceMax}
                setPriceMax={setPriceMax}
                shouldClear={shouldClear}
                setShouldClear={setShouldClear}
            />
            <TypeSelector type={type} setType={setType} />
            <LodgingFilter
                hasIncludedLodging={hasIncludedLodging}
                setHasIncludedLodging={setHasIncludedLodging}
            />
            <SpeciesSelector
                type={type}
                selectedSpecies={species}
                setSelectedSpecies={setSpecies}
            />
            <AmenitySelector
                selectedAmenities={amenities}
                setSelectedAmenities={setAmenities}
            />
        </Box>
    )
}

function useStyles() {
    return {
        root: {
            display: "flex",
            flexDirection: "column",
        },
    }
}
